import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import Component from './Component';

import {getTours} from '../SearchResult/Actions';

const stateToProps = (state) => {
  return {
    cities: state.main.cities,
    isShowSearchHomePage: state.main.isShowSearchHomePage,
  }
};

const dispatchToProps = (dispatch) => {
  return {
    getTours: (cityId, history) => {
      dispatch(getTours(cityId, history))
    },
  }
};

export default withRouter(connect(stateToProps, dispatchToProps)(Component));


// WEBPACK FOOTER //
// ./src/app/containers/Home/index.js